export class AvailabilityModel {
  from_time: any | null = null
  to_time: any | null = null
  day_id: number | null = 0
  id: string | null = ''
}
